import { IncidentPriorityTypes, IncidentStatusTypes } from "../../../DTOs";
import { basicValidation } from "../basicValidation";

const fieldValidation = {
    id: (value:string) =>  basicValidation.resourceId.isValid(value),
    type: (value:string) =>  basicValidation.resourceText.isValid(value, false, 100),
    title: (value:string) =>  basicValidation.resourceText.isValid(value, false, 100),
    description: (value:string) =>  basicValidation.resourceText.isValid(value, false, 20000),
    solutionDescription: (value:string) =>  basicValidation.resourceText.isValid(value, true, 20000),
    anonymousSelected: (value:boolean) => basicValidation.validateBoolean(value),
    email: (value:string, anonymousSelected:boolean, notificationsSelected:boolean) => 
        !anonymousSelected || notificationsSelected
            ? basicValidation.isValidEmail(value, false)
            : basicValidation.isValidEmail(value, true),
    name: (value:string, anonymousSelected:boolean) =>  
        anonymousSelected
            ? basicValidation.resourceText.isValid(value, true, 100)
            : basicValidation.resourceText.isValid(value, false, 100),
    notificationsSelected: (value:boolean) => basicValidation.validateBoolean(value),
    status: (value:string) => IncidentStatusTypes.some(status => status === value),
    priority: (value:string) =>  IncidentPriorityTypes.some(priority => priority === value),
    message: (value:string) => basicValidation.resourceText.isValid(value, false, 20000),
    fileUploadSlotId: (value:string) => basicValidation.resourceId.isValidOrEmpty(value)
};

export const incidentFieldValidation = {
    incident : fieldValidation
};